import toastr from 'toastr';
import { MutationOptions } from 'react-query';
import { BaseFetchError } from '../../baseFetch';
import {
  updateOrder,
  updateOrderShowDeltaT,
  updateOrderStatus,
} from './orders.api';
import {
  OrderUpdate,
  UpdateOrderResponse,
  UpdateShowDeltaTResponse,
} from './orders.schema';
import { ExitStatusResponse } from '../../schemas/ExitStatusResponseSchema';

export const getUpdateOrderShowDeltaTMutation = (): MutationOptions<
  UpdateShowDeltaTResponse,
  Error,
  { orderId: number; showDeltaT: boolean }
> => ({
  mutationFn: ({ orderId, showDeltaT }) =>
    updateOrderShowDeltaT(orderId, showDeltaT),
});

export const getUpdateOrderMutation = (): MutationOptions<
  UpdateOrderResponse,
  Error,
  { orderId: number; updatedOrder: OrderUpdate }
> => ({
  mutationFn: ({ orderId, updatedOrder }) => updateOrder(orderId, updatedOrder),
  onSuccess: () => {
    toastr.success('Order updated');
  },
  onError: async error => {
    if (error instanceof BaseFetchError) {
      const errorDetails = await (() => {
        if (!error.response) {
          return 'Unknown error';
        }

        const responseContentType = error.response.headers.get('Content-Type');
        if (!responseContentType) {
          return 'Unknown error';
        }

        if (responseContentType.includes('application/json')) {
          return error.response.json().then(errorJson => errorJson.detail);
        } else {
          return error.response.text();
        }
      })();

      toastr.error(`Unable to update order: ${errorDetails}`);
    } else {
      toastr.error(`Unable to update order`);
    }
  },
});

export const getUpdateOrderStatusMutation = (): MutationOptions<
  ExitStatusResponse,
  Error,
  { orderUuid: string; newStatus: number }
> => ({
  mutationFn: ({ orderUuid, newStatus }) =>
    updateOrderStatus(orderUuid, newStatus),
  onSuccess: () => {
    toastr.success('Order status updated');
  },
  onError: async error => {
    if (error instanceof BaseFetchError) {
      const errorDetails = await (() => {
        if (!error.response) {
          return 'Unknown error';
        }

        const responseContentType = error.response.headers.get('Content-Type');
        if (!responseContentType) {
          return 'Unknown error';
        }

        if (responseContentType.includes('application/json')) {
          return error.response.json().then(errorJson => errorJson.detail);
        } else {
          return error.response.text();
        }
      })();

      toastr.error(`Unable to update order status: ${errorDetails}`);
    } else {
      toastr.error(`Unable to update order status`);
    }
  },
});
